<!-- 已有计划列表 -->
<style scoped="scoped" lang="scss">
/* .baoyangxianginput {
width: 30px;
} */
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 120px;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/plan/getPlanMain" getKey="rows" :columns="columns" @selectionChange="selectionChange" @rowClick="rowClick" @afterGet="afterGet">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"> </yi_data_select>
            <!--            <yi_cross_select multiple :selectTitle="'name'" :component="'web_base_matter_list'"-->
            <!--                :ids.sync="yt.conditions.materialIdList">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(params)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <!-- <template #buttonsL>
				<el-button size="mini"
					@click="yt.showEditDialog('xinzeng',null,'w2',beforeShowEditDialog);setDefaultValue1()"
					type="primary">
					{{$t('xinzeng')}}
				</el-button>
				<el-button size="mini" @click="yt.showEditDialog('hedan',null,'80%');" type="primary" plain>
					{{$t('hedan')}}
				</el-button>
				<el-button style="margin-left: 10px;" size="mini" @click="show = !show" plain>
					{{$t('daoru')}}
				</el-button>
			</template> -->
      <!-- 右侧按钮插槽 -->
      <!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"
					@click="exportExcel()"></el-button>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
					@click="yt.showColumnsDialog()"></el-button>
			</template> -->
      <template #zhuangtai="scope">
        <el-tag :type="scope.row.status === 2 ? 'success' : 'warning'" size="mini">
          {{ $t(store.state.dictJsonAll['PRODUCTION_PLAN_STATUS'][scope.row.status]) }}
        </el-tag>
      </template>
      <!-- <template #caozuo="scope">
				<el-row :gutter="10">
					<el-col v-if="scope.row.children || (scope.row.parentId == null)" :span="0.1">
						<el-button v-if="scope.row.status==1" type="text"
							@click="yt.showEditDialog('paichan', scope.row,'w1');setDefaultValue();">{{$t('paichan')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="scope.row.schedulingQuantity>0" type="text"
							@click="yt.showEditDialog('shengchangongdan', scope.row,'900px')">
							{{$t('shengchangongdan')}}
						</el-button>
					</el-col>
					<el-col :span="0.1" v-if="scope.row.children || (scope.row.parentId == null)">
						<el-button v-if="scope.row.status==1" type="text"
							@click="yt.showEditDialog('bianji', scope.row,'w2', beforeEdit)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" v-if="scope.row.type==1"
							@click="yt.showEditDialog('hedanjilu', scope.row,'900px')">
							{{$t('hedanjilu')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button :loading="store.state.global_loading" v-if="scope.row.schedulingQuantity==0"
							type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/production/plan/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
					<el-button v-if="scope.row.schedulingQuantity==0 && scope.row.parentId==null" type="text"
						@click="yt.showEditDialog('zengjiafudan', scope.row,'900px',beforeShowEditDialog)">
						{{$t('zengjiafudan')}}
					</el-button>
				</el-row>
			</template> -->
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import combine from '@@/pages/web/order_management/production_plan/combine';
import importExcel from '@@/pages/web/order_management/production_plan/import_excel';
import work_order from '@@/pages/web/order_management/production_plan/work_order/list';
import combination_record from '@@/pages/web/order_management/production_plan/combination_record';

export default {
  name: 'web_order_management_production_plan_senmusi_list',
  components: {
    importExcel,
    combine,
    work_order,
    combination_record
  },
  data() {
    return {
      selectedRows: [],
      actualCavity: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      schedulingQuantityDisabled: true,
      mouldStatus: '',
      objectList: '',
      schedulingList: '',
      parentIds: '',
      scheduling: '',
      cavity: '',
      cycle: '',
      showTitle: false,
      showTitle1: false,
      disabled1: true,
      show: false,
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      isShowAdaptEqSelect: true,
      params: {
        orderBy: 'createTime desc',
        parentId: this.$attrs.parentPlan.id
      },
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          width: 130
        },
        {
          label: 'jihuadanhao',
          prop: 'no',
          sort: 'string',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'quantity',
          sort: 'number',
          width: 130
        },
        {
          label: 'yipaichanshuliang',
          prop: 'schedulingQuantity',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'zhuangtai',
          type: 'slot',
          prop: 'status'
        },
        {
          label: 'jihuakaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 150
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'endTime',
          type: 'time',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        }
        // {
        // 	label: 'caozuo',
        // 	type: 'slot',
        // 	width: 230,
        // 	fixed: 'right'
        // }
      ],
      ids: ''
    };
  },
  computed: {
    maxValue() {
      return this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity;
    },
    maxValue2() {
      const quantity = this.yt.editObj.children.map(qt => {
        return qt.quantity;
      });
      const schedulingQuantity = this.yt.editObj.children.map(items => {
        return items.schedulingQuantity;
      });
      return quantity + '' - (schedulingQuantity + '');
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc',
        parentId: this.$attrs.parentPlan.id
      };
      this.yt.get(1);
      this.yt.isShowPagination = true;
      this.utils.event_hub.$on('ORDER_MANAGEMENT_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
  },
  watch: {
    'yt.editObj.mouldId': {
      handler(n) {
        this.isShowAdaptEqSelect = false;
        this.$nextTick(() => {
          this.isShowAdaptEqSelect = true;
        });
        if (n) {
          this.disabled1 = false;
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.action': {
      handler(n) {
        if (n === 'xinzeng') {
          this.yt.editObj.children = [];
        }
        if (n === 'zengjiafudan') {
          this.yt.editObj.children = [];
        }
        if (n === 'paichan') {
          if (this.yt.editObj) {
            this.scheduling = this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity;
          }
        }
        if (n === 'hedanjilu') {
          if (this.yt.isShowEditDialog == true) {
            this.yt.get(1);
          }
        }
      },
      immediate: false,
      deep: true
    },
    'yt.isShowEditDialog': {
      handler(n) {
        if (this.yt.editObj.action == 'hedanjilu' && n == false) {
          this.yt.get(1);
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.curQuantity': {
      handler(n) {
        if (n > this.scheduling) {
          n = this.scheduling;
          this.$set(this.yt.editObj, 'curQuantity', n.toFixed(0));
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    //一个方法回显勾选
    selectionChange(rows) {
      //找出当页没选中的
      let currentPageUnselecte = [];
      A: for (let i = 0; i < this.yt.list.length; i++) {
        for (let j = 0; j < rows.length; j++) {
          if (this.yt.list[i].id == rows[j].id) {
            continue A;
          }
        }
        currentPageUnselecte.push(this.yt.list[i]);
      }

      //删除没被选中的
      for (let i = 0; i < this.selectedRows.length; i++) {
        for (let j = 0; j < currentPageUnselecte.length; j++) {
          if (this.selectedRows[i].id == currentPageUnselecte[j].id) {
            this.selectedRows.splice(i, 1);
            i--;
          }
        }
      }

      //循环判断selectedRows，加入rows
      A: for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < this.selectedRows.length; j++) {
          if (this.selectedRows[j].id == rows[i].id) {
            continue A;
          }
        }
        this.selectedRows.push(rows[i]);
      }
    },
    afterGet() {
      setTimeout(() => {
        let tmp = this.utils.copy(this.selectedRows);
        for (let i = 0; i < tmp.length; i++) {
          for (let j = 0; j < this.yt.list.length; j++) {
            if (tmp[i].id == this.yt.list[j].id) {
              this.yt.$refs.table.toggleRowSelection(this.yt.list[j], true);
            }
          }
        }
      }, 800);
    },
    //排产保存
    getScheduling(row) {
      this.objectList = row;
      this.yt.editObj.loading = true;
      console.log('yt.editObj', row);
      // isCheckMouldStatus
      return this.http
        .post('/web/production/plan/scheduling?isCheckMouldStatus=true', {
          ...row
        })
        .then(response => {
          console.log('response', response);
          if (response.data.code == 0) {
            this.mouldStatus = this.$t(this.store.state.dictJsonAll['BASIC_MOULD_STATUS'][response.data.mouldStatus]);
            this.$confirm('模具处于' + this.mouldStatus + '请确认是否选择排产?', '排产确认', {
              confirmButtonText: '仍继续排产',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.getCheckMouldStatu();
              })
              .catch(() => {
                this.yt.editObj.loading = false;
              });
          } else {
            this.yt.get(1);
            this.$message.success(this.$t('chenggong'));
            this.yt.isShowEditDialog = false;
            this.yt.editObj.loading = false;
          }
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    getCheckMouldStatu() {
      return this.http
        .post('/web/production/plan/scheduling?isCheckMouldStatus=false', {
          ...this.objectList
        })
        .then(res => {
          this.yt.get(1);
          this.$message.success(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.editObj.loading = false;
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    getCheckScheduling() {
      return this.http
        .post('/web/production/plan/schedulingAndGiveOut?isCheckMouldStatus=false', {
          ...this.schedulingList
        })
        .then(res => {
          this.yt.get(1);
          this.$message.success(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.editObj.loading = false;
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    //保存并排产
    //web/production/plan/schedulingAndGiveOut
    getSchedulingAndGiveOut(row) {
      this.schedulingList = row;
      this.yt.editObj.loading = true;
      return this.http
        .post('/web/production/plan/schedulingAndGiveOut?isCheckMouldStatus=true', {
          ...row
        })
        .then(response => {
          if (response.data.code == 0) {
            this.mouldStatus = this.$t(this.store.state.dictJsonAll['BASIC_MOULD_STATUS'][response.data.mouldStatus]);
            this.$confirm('模具处于' + this.mouldStatus + '请确认是否选择排产发放?', '排产发放确认', {
              confirmButtonText: '仍继续排产',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.getCheckScheduling();
              })
              .catch(() => {
                this.yt.editObj.loading = false;
              });
          } else {
            this.yt.get(1);
            this.$message.success(this.$t('chenggong'));
            this.yt.isShowEditDialog = false;
            this.yt.editObj.loading = false;
          }
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    //导出
    exportExcel() {
      let params = this.yt.conditions;
      params.materialId = this.yt.conditions.materialIdList;
      params.startTimeStart = this.yt.conditions.startTime;
      params.startTimeEnd = this.yt.conditions.endTime;
      delete params.startTime;
      delete params.endTime;
      delete params.materialIdList;
      delete params.orderBy;
      return this.http
        .get('/web/report/export/production_plan_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    /**
     * 计划数量
     * @param value
     */
    changePlanNumber(value) {
      // 计划完成时间=计划开始时间(时间戳)+本次计划数量*标准周期*1000/模穴数
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.curQuantity) {
        const endTime = this.yt.editObj.startTime + (this.yt.editObj.curQuantity * this.cycle * 1000) / this.cavity;
        this.$set(this.yt.editObj, 'endTime', endTime);
      }
    },
    /**
     * 计划开始时间
     * @param value
     */
    changeStartTime(value) {
      if (this.yt.editObj.startTime && this.yt.editObj.endTime && this.yt.editObj.startTime >= this.yt.editObj.endTime) {
        this.$message.error(this.$t('jihuakaishishijianbunengdayujiahuawanchengshijian'));
        this.yt.editObj.startTime = '';
      }
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.curQuantity) {
        const endTime = this.yt.editObj.startTime + (this.yt.editObj.curQuantity * this.cycle * 1000) / this.cavity;
        this.$set(this.yt.editObj, 'endTime', endTime);
      }
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.endTime !== undefined && this.yt.editObj.endTime !== '' && this.yt.editObj.endTime !== null) {
        const curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity;
        this.$set(this.yt.editObj, 'curQuantity', curQuantity);
      }
    },
    /**
     * 计划结束时间
     * @param value
     */
    changeEndTime(value) {
      if (this.yt.editObj.startTime && this.yt.editObj.endTime && this.yt.editObj.startTime >= this.yt.editObj.endTime) {
        this.$message.error(this.$t('jihuawanchengshijianbunengxiaoyujihuakaishishijian'));
        this.yt.editObj.endTime = '';
      }
      // 本次计划数量=(计划完成时间(时间戳)-计划开始时间(时间戳))/1000/标准周期*模穴数
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.endTime !== undefined && this.yt.editObj.endTime !== '' && this.yt.editObj.endTime !== null) {
        const curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity;
        this.$set(this.yt.editObj, 'curQuantity', curQuantity);
      }
    },
    /**
     * 选中模糊
     * @param items
     */
    getItems(items) {
      this.cavity = items.cavity;
      this.cycle = items.cycle;
      this.actualCavity = items.actualCavity;
      if (this.actualCavity) {
        this.$set(this.yt.editObj, 'actualCavity', this.actualCavity);
        if (this.yt.editObj.children) {
          for (let i = 0; i < this.yt.editObj.children.length; i++) {
            this.$set(this.yt.editObj.children[i], 'actualCavity', this.actualCavity);
          }
        }
      }
    },

    setDefaultValue1() {
      if (this.store.state.organizations.length > 0 && this.store.state.organizations[0].children.length > 0 && this.store.state.organizations[0].children[0].children.length > 0) {
        this.yt.editObj.orgId = this.store.state.organizations[0].children[0].children[0]['id'];
      }
    },
    onInput() {
      this.$forceUpdate();
    },
    beforeEdit(editObj) {
      if (editObj.children === undefined) {
        this.$set(editObj, 'children', []);
      }
      console.log('schedulingQuantityDisabled', editObj.schedulingQuantity);
      if (editObj.schedulingQuantity === 0) {
        this.schedulingQuantityDisabled = false;
      } else {
        this.schedulingQuantityDisabled = true;
      }
      return editObj;
    },
    setDefaultValue() {
      this.yt.editObj.priority = 1;
      this.yt.editObj.startTime = [];
      this.yt.editObj.endTime = [];
    },
    submitCombine() {
      let planIdList = this.$refs['combineOrders'].planIdList;
      if (planIdList !== null) {
        return this.http
          .post('/web/production/plan/merge', planIdList)
          .then(response => {
            this.yt.get(1);
            this.yt.isShowEditDialog = false;
          })
          .catch(error => {
            this.$message.error(error);
          });
      } else {
        this.utils.errorMessage(this.$t('qingxuanzexuyaodedan'));
      }
    },

    beforeShowEditDialog(editObj) {
      console.log('asdklasdnabb:', editObj.action);
      if (editObj.action === 'xinzeng' || editObj.action === 'zengjiafudan') {
        editObj.children = [
          {
            no: '',
            materialId: '',
            quantity: undefined,
            erpNo: '',
            remark: ''
          }
        ];
      }
      return editObj;
    },
    setChildrenItem() {
      this.yt.editObj.children.push({
        no: '',
        materialId: '',
        quantity: undefined,
        erpNo: '',
        remark: ''
      });
    },
    addItem() {
      this.showTitle = true;
      this.showTitle1 = true;
      console.log('this.yt.editObj.children', this.yt.editObj.children);
      this.yt.editObj.children.push({
        no: '',
        materialId: '',
        quantity: undefined,
        erpNo: '',
        remark: ''
      });
    },
    deleteItem(key) {
      this.yt.editObj.children = this.yt.editObj.children.filter((item, index) => {
        return index !== key;
      });
    }
  }
};
</script>
